import {
    Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver
} from "@angular/core";
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { AlertService, AlertComponent } from '../../../../../shared/alert';
import { MonthlyCut } from '../../../../../_models';
import { UnitTableComponent } from '../../units/unit-table';

@Component({
    selector: 'app-monthly-cut-new',
    templateUrl: './monthly-cut-new.component.html',
})

export class MonthlyCutNewComponent implements OnInit {
    @ViewChild('alert',
        { read: ViewContainerRef }) alertRef: ViewContainerRef;
    investorsCount = 0;
    inPool = 0;
    unitTableShow = {
        floor: true,
        id_orange: true,
        investor: true,
        area_interior: false,
        area_common: false,
        area_terrace: false,
        total_area: false,
        area_terrace_half: false,
        pool_percentage: false,
        in_pool: true,
        detail: false
    };

    generateCut$: Observable<Object>;
    @ViewChild(UnitTableComponent) unitTable: UnitTableComponent;
    constructor(private _cfr: ComponentFactoryResolver,
        private _alertService: AlertService,
        private _router: Router,
        private monthlyCut: MonthlyCut
    ) { }

    ngOnInit() {
        this.monthlyCut.getSummary().subscribe(summary => {
            this.inPool = summary.total_units_in_pool;
            this.investorsCount = summary.total_investors_with_pool_units;
        });
        this.unitTable.getData(`in_pool=1&include=investor,property`).subscribe(units => {
            let now = new Date();
            this.generateCut$ =
                this.monthlyCut.post({
                    month: now.getMonth() + 1, year: now.getFullYear()
                });
            let monthName = this.monthlyCut.translatedMonths[now.getMonth() + 1];
            this.showInfoAlert(
                `Se generará el corte de ${monthName} ${now.getFullYear()}`)
        });
    }
    showInfoAlert(message) {
        this.alertRef.clear();
        let factory = this._cfr.resolveComponentFactory(AlertComponent);
        let ref = this.alertRef.createComponent(factory);
        ref.changeDetectorRef.detectChanges();
        this._alertService.info(message);
    }
    error(error) {
        console.error(error);
    }
    end() {
        this._router.navigate([`/monthly-cuts/${this.monthlyCut.instance.id}`]);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-new/monthly-cut-new.component.ts